import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useCompanyData } from "../../../lib/useMockData";

export default function TeamSection() {
  const { teamData } = useCompanyData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-navy text-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-14">
              <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
                {teamData.label}
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold leading-tight">
                {teamData.title}
              </h2>
              <p className="mt-4 text-sm text-white/60 max-w-2xl mx-auto leading-relaxed">
                {teamData.subtitle}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {teamData.members.map((member, idx) => (
              <ScrollReveal key={member.role} direction="up" delay={idx * 100}>
                <div className="p-6 bg-airdoa-navy-light/50 rounded-lg border border-white/10 h-full">
                  <p className="text-[10px] font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
                    {member.role}
                  </p>
                  <p className="text-base font-serif font-semibold mb-3">
                    {member.name}
                  </p>
                  <p className="text-sm text-white/50 leading-relaxed">
                    {member.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}